// extracted by mini-css-extract-plugin
export default {"wrapper":"Zt8Si8weUgu53vDEZBiQ","title":"jgP8TUdSxQkZ8V3DXQ6n","dataConnectionsList":"Nv_OjKTgslHSeU4617Wv","dataConnectionsListItem":"NNjovJqD5krlhb3uXRlu"};